export * from './carta-de-quitacao.component';
